import React, { useState, useEffect, useContext } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { ReactReduxContext, useSelector } from 'react-redux'
import { Button, Spinner } from 'react-bootstrap'
import apiClient from 'api/config/apiClient'
import Typography from 'components/atoms/Typography'
import CustomModal from 'components/molecules/CustomModal'
import './EquipamentoMedicoPopup.scss'

// CustomPage renderiza tambem o site publico, entao o pop-up so consulta o
// status dentro da area logada. Mesmo criterio da implementacao anterior.
const LOGGED_AREA_PATHS = ['/app', '/home-cooperado']

// Reaparece a cada acesso enquanto a resposta do cooperado for "nao_respondeu".
function EquipamentoMedicoPopup({ user }) {
  const { store } = useContext(ReactReduxContext)
  const history = useHistory()
  const { pathname } = useLocation()
  const session = useSelector((state) => state?.auth?.user)

  const [open, setOpen] = useState(false)
  const [step, setStep] = useState('question')
  const [confirmNotUse, setConfirmNotUse] = useState(false)
  const [saving, setSaving] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')

  // Unica origem do CRM: vem do Benner via getUser, o Drupal nao o conhece.
  const crm = user?.crm || session?.crm || ''

  // menu traz so o perfil de maior precedencia (um cooperado auditor vem como
  // "auditor"), entao a role e a fonte confiavel.
  const roles = user?.roles || session?.roles || []
  const isCooperado = roles.includes('cooperado') || user?.menu === 'cooperado'
  const isAllowedPath = LOGGED_AREA_PATHS.some((p) => (pathname || '').startsWith(p))

  useEffect(() => {
    if (!isCooperado || !isAllowedPath || !store) return

    apiClient
      .request('cache-disable/equipment_usage_status', { crm: String(crm), store })
      .then((res) => {
        const status = res?.applications?.medicalEquipmentUsage?.usageStatus
        if (status?.should_show) setOpen(true)
      })
      .catch(() => {})
  }, [isCooperado, isAllowedPath, crm, store])

  const salvarResposta = async (resposta) => {
    setErrorMsg('')
    setSaving(true)
    try {
      const res = await apiClient.request('cache-disable/equipment_usage_save', {
        crm: String(crm),
        resposta,
        store,
      })
      const saved = res?.applications?.medicalEquipmentUsage?.saveMedicalEquipmentUsage?.submission_id
      return Boolean(saved)
    } catch (error) {
      return false
    } finally {
      setSaving(false)
    }
  }

  const fechar = () => {
    setOpen(false)
    setStep('question')
    setConfirmNotUse(false)
  }

  // Temporario: a resposta "usa" e gravada ja no clique. Futuramente so sera
  // registrada quando o cooperado concluir o cadastro do equipamento.
  const handleYes = async () => {
    const ok = await salvarResposta('usa')
    if (!ok) {
      setErrorMsg('Não foi possível registrar sua resposta. Tente novamente mais tarde.')
      return
    }
    fechar()
    history.push('/app/equipamento-medico')
  }

  const handleNo = () => setStep('justify')

  const handleBack = () => {
    setStep('question')
    setConfirmNotUse(false)
    setErrorMsg('')
  }

  const handleSubmitNo = async () => {
    const ok = await salvarResposta('nao_usa')
    if (!ok) {
      setErrorMsg('Não foi possível registrar sua resposta. Tente novamente mais tarde.')
      return
    }
    fechar()
  }

  return (
    <div className="medical-equipment-popup-modal">
      <CustomModal open={open} closeModal={fechar} size="sm" title="Cadastro de Equipamentos UNIMED">
        {step === 'question' && (
          <div className="text-center">
            <Typography variant="p" color="gray-100">
              Você realiza algum exame complementar pela Unimed?
            </Typography>
            {errorMsg && <p className="text-danger text-center mt-2 mb-0">{errorMsg}</p>}
            <div className="d-flex justify-content-center mt-3">
              <Button variant="primary" className="mx-1" onClick={handleYes} disabled={saving}>
                {saving ? <Spinner animation="border" size="sm" /> : 'Sim'}
              </Button>
              <Button variant="primary" className="mx-1" onClick={handleNo} disabled={saving}>
                Não
              </Button>
            </div>
          </div>
        )}

        {step === 'justify' && (
          <div>
            <div className="mt-2 d-flex align-items-start" style={{ gap: '10px', padding: '0px 25px 0px' }}>
              <input
                type="checkbox"
                id="equipmentConfirmNotUse"
                checked={confirmNotUse}
                onChange={(e) => setConfirmNotUse(e.target.checked)}
                style={{ flexShrink: 0, width: '20px', height: '20px', cursor: 'pointer', marginTop: '2px' }}
              />
              <label htmlFor="equipmentConfirmNotUse" style={{ margin: 0, textAlign: 'left' }}>
                <Typography variant="span" color="gray-100">
                  Declaro que não realizo exames complementares aos beneficiários Unimed.
                </Typography>
              </label>
            </div>
            {errorMsg && <p className="text-danger text-center mt-2 mb-0">{errorMsg}</p>}
            <div className="d-flex justify-content-center mt-3" style={{ marginBottom: '1rem' }}>
              <Button variant="secondary" className="mx-1" onClick={handleBack} disabled={saving}>
                Voltar
              </Button>
              <Button variant="primary" className="mx-1" onClick={handleSubmitNo} disabled={!confirmNotUse || saving}>
                {saving ? <Spinner animation="border" size="sm" /> : 'Enviar'}
              </Button>
            </div>
          </div>
        )}
      </CustomModal>
    </div>
  )
}

export default EquipamentoMedicoPopup
